import React from 'react';

import { CommonSubForm } from '@vlabs/pages/handlers/forms';
import StepTitle from '@vlabs/shared/legacy-components/steps/StepTitle';
import { Step } from '@vlabs/uikit';
import i18next from 'i18next';

import st from './shared.module.sass';

function StepCommon() {
  return (
    <Step
      className={st.Step}
      title={(
        <StepTitle>
          {i18next.t('handlers:введите уникальное название сценария')}
        </StepTitle>
      )}
    >
      <CommonSubForm />
    </Step>
  );
}

StepCommon.fieldNames = [
  'description',
];

export { StepCommon };
